import React, { PureComponent } from 'react';

class CollapsibleContent extends PureComponent {

  render() {

    const { classList = [], ...restOfProps } = this.props;

    return(
      <div className={'content ' + classList.join(' ')} {...restOfProps}>
        {this.props.children}
      </div>
    );
  }
}

export default CollapsibleContent;



// WEBPACK FOOTER //
// ./js/components/global/collapsible/CollapsibleContent.js